import { render } from "./LogoutConfirmModal.vue?vue&type=template&id=6e1d270e"
import script from "./LogoutConfirmModal.vue?vue&type=script&lang=js"
export * from "./LogoutConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__